import { render } from "./HeaderCont.vue?vue&type=template&id=c6c10a10"
const script = {}

import "./HeaderCont.vue?vue&type=style&index=0&id=c6c10a10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__